// Single reader for the clinical-proband designation (TGC-1429 remediation).
//
// TGC-1429 made the proband movable (promote) and clearable (Remove Proband),
// which splits "who gets the arrow" into three states that only the ROOT row
// can disambiguate:
//
//   explicit — some member carries isProband === true (promoted or designated
//              at creation). Arrow on that member.
//   cleared  — no member is true and the root row carries isProband === false
//              PRESENT: a clinician explicitly removed the proband (or the
//              family was created/migrated with the designation materialised).
//              No arrow — "no active proband" is a real state.
//   legacy   — the root row has NO isProband field at all: un-migrated data
//              (pre-0015, or a family 0015 skipped). Fall back to the
//              structural root so old pedigrees keep their arrow.
//
// The discriminator is deliberately ROOT-ONLY: the pedigree-config save
// historically wrote coerced isProband:false onto MEMBER docs, so
// false-present on members proves nothing; the root row is exempt from that
// write path. Every consumer (Canvas arrow, ContextMenu Make/Remove Proband,
// ChartBox migrate guard) must go through this selector rather than
// re-interpreting flag presence.
export function getProbandState(members) {
  const list = Array.isArray(members) ? members : [];

  const explicit = list.find((m) => m?.isProband === true);
  if (explicit) {
    return { state: 'explicit', probandPid: explicit.pid ?? null };
  }

  // The structural root is the one row carrying proBandId. Defensive: with
  // zero (or anomalous duplicate) proBandId rows we degrade to "no arrow"
  // rather than guessing.
  const root = list.find((m) => m?.proBandId != null);
  if (!root) {
    return { state: 'legacy', probandPid: null };
  }

  if (root.isProband === false) {
    return { state: 'cleared', probandPid: null };
  }

  return { state: 'legacy', probandPid: root.pid ?? null };
}
